if (!customElements.get('ingu-carousel')) {
  customElements.define(
    'ingu-carousel',
    class InguCarousel extends HTMLElement {
      connectedCallback() {
        // Wait for Swiper to be available
        if (typeof Swiper === 'undefined') {
          document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
          this.init();
        }
      }

      init() {
        const wrapper = this.querySelector('.ingu-carousel__wrapper');
        const pagination = this.querySelector('.ingu-carousel__pagination');
        const btnPrev = this.querySelector('.ingu-carousel__btn--prev');
        const btnNext = this.querySelector('.ingu-carousel__btn--next');

        if (!wrapper) return;

        // Read config from data attributes
        const slidesDesktop = parseFloat(this.dataset.slidesPerView || '1');
        const slidesMobile = parseFloat(
          this.dataset.slidesPerViewMobile || '1',
        );
        const slidesTablet = parseFloat(
          this.dataset.slidesPerViewTablet || slidesDesktop,
        );
        const spaceBetween = parseInt(this.dataset.spaceBetween || '16');
        const loop = this.dataset.loop !== 'false';
        const autoplay = this.dataset.autoplay
          ? parseInt(this.dataset.autoplay)
          : false;
        const centeredSlides = this.dataset.centered === 'true';

        this.swiper = new Swiper(this, {
          wrapperClass: 'ingu-carousel__wrapper',
          slideClass: 'ingu-carousel__slide',
          loop,
          centerInsufficientSlides: true,
          centeredSlides,
          watchOverflow: true,
          spaceBetween,
          autoplay: autoplay
            ? { delay: autoplay, pauseOnMouseEnter: true }
            : false,
          pagination: pagination
            ? {
                el: pagination,
                clickable: true,
              }
            : false,
          navigation:
            btnPrev && btnNext
              ? {
                  prevEl: btnPrev,
                  nextEl: btnNext,
                }
              : false,
          breakpoints: {
            0: { slidesPerView: slidesMobile },
            750: { slidesPerView: slidesTablet },
            990: { slidesPerView: slidesDesktop },
          },
          on: {
            // Show nav buttons once initialized
            init(swiper) {
              swiper.el
                .querySelectorAll('.ingu-carousel__btn')
                .forEach((btn) =>
                  btn.classList.add('ingu-carousel__btn--ready'),
                );
            },
          },
        });
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
      }
    },
  );
}
